import React from 'react';
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

interface SOIProps {
  selectedOption: number;
  setOption: (e: number) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    hidden: {
      visibility: 'hidden',
      '-webkit-appearance': 'none',
      '-moz-appearance': 'none',
      '-ms-appearance': 'none',
      '-o-appearance': 'none',
      appearance: 'none',
    },
    formControl: {
      margin: 0,
      padding: theme.spacing(2),
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.palette.grey[100],
      },
    },
    selectedFormControl: {
      margin: 0,
      padding: theme.spacing(2),
      backgroundColor: theme.palette.grey[200],
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      cursor: 'pointer',
    },
    optionTitle: {
      fontWeight: 500,
      fontSize: '0.875rem',
      marginBottom: theme.spacing(0.5),
    },
    optionSubtitle: {
      fontSize: '0.75rem',
      color: theme.palette.grey[600],
    },
  }),
);

export default function RadioButtonsGroup(props: SOIProps) {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.setOption(+event.target.value);
  };

  return (
    <Box style={{ width: '100%' }}>
      <FormControl
        component="fieldset"
        style={{ textAlign: 'left', width: '100%' }}
      >
        <RadioGroup
          aria-label="schedule-type"
          name="schedule-type"
          value={props.selectedOption}
          onChange={handleChange}
        >
          <FormControlLabel
            className={
              props.selectedOption === 0
                ? classes.selectedFormControl
                : classes.formControl
            }
            value={0}
            control={<Radio className={classes.hidden} />}
            label={
              <Box>
                <Typography className={classes.optionTitle}>
                  {t('operationHours.regularHours')}
                </Typography>
                <Typography className={classes.optionSubtitle}>
                  {t('operationHours.editGeneralSchedule')}
                </Typography>
              </Box>
            }
          />
          <FormControlLabel
            className={
              props.selectedOption === 1
                ? classes.selectedFormControl
                : classes.formControl
            }
            value={1}
            control={<Radio className={classes.hidden} />}
            label={
              <Box>
                <Typography className={classes.optionTitle}>
                  {t('operationHours.specialHours')}
                </Typography>
                <Typography className={classes.optionSubtitle}>
                  {t('operationHours.editRangeDayAdjustment')}
                </Typography>
              </Box>
            }
          />
          <FormControlLabel
            className={
              props.selectedOption === 2
                ? classes.selectedFormControl
                : classes.formControl
            }
            value={2}
            control={<Radio className={classes.hidden} />}
            label={
              <Box>
                <Typography className={classes.optionTitle}>
                  {t('operationHours.specialHours')}
                </Typography>
                <Typography className={classes.optionSubtitle}>
                  {t('operationHours.editSingleDayAdjustment')}
                </Typography>
              </Box>
            }
          />
          <FormControlLabel
            className={
              props.selectedOption === 3
                ? classes.selectedFormControl
                : classes.formControl
            }
            value={3}
            control={<Radio className={classes.hidden} />}
            label={
              <Box>
                <Typography className={classes.optionTitle}>
                  {t('operationHours.truckDeliveryDays')}
                </Typography>
                <Typography className={classes.optionSubtitle}>
                  {t('operationHours.editDaysAcceptingDeliverySupplies')}
                </Typography>
              </Box>
            }
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
}
